<template lang="pug">
  .sidebar-layout
    .sidebar-layout__sidebar-wrapper
      admin-sidebar(:items="sidebar")
    .sidebar-layout__views-wrapper
      router-view
</template>

<script>
import api from '@/api'
import { ADMIN_SIDEBAR, EMPLOYEE_SIDEBAR } from '@/util/consts.js'

import AdminSidebar from '@/components/layouts/admin-sidebar/AdminSidebar'

export default {
  name: 'Admin',

  components: {
    AdminSidebar
  },
  data: () => ({
    userType: null,
    sidebar: ADMIN_SIDEBAR
  }),
  async created () {
    try {
      const { data } = await api.account.get()
      this.userType = data.user_type
      if (this.userType === 'employee') {
        this.sidebar = EMPLOYEE_SIDEBAR
      }
    } catch (error) {
      console.error('Failed to fetch user type:', error)
      this.userType = null
    }
  },
}
</script>
